import { render, staticRenderFns } from "./StudentHistory.vue?vue&type=template&id=7e9a5cf2&"
import script from "./StudentHistory.vue?vue&type=script&lang=js&"
export * from "./StudentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StudentHistory.vue"
export default component.exports